module.exports = __webpack_public_path__ + "img/logo_px40_flutter.446cdb2b.png";